// look for [data-fileinput]
export function bindFileInputs(content?: Element | Document | null | undefined) {    
    if (!content) {
        content = document;
    }
    content.querySelectorAll<HTMLElement>('[data-fileinput]').forEach(fInput => {
        const fEvent = fInput.getAttribute('fileinput-event');
        if (fEvent === null || fEvent !== 'true') {
            fInput.setAttribute('fileinput-event', 'true');
            const inputElem = fInput.querySelector<HTMLInputElement>('[type=file]');
            if (inputElem !== null) {
                inputElem.addEventListener('dragenter', fileDragEnter);
                inputElem.addEventListener('dragover', evt => { evt.preventDefault(); });
                inputElem.addEventListener('dragleave', fileDragLeave);
                inputElem.addEventListener('drop', fileDrop);
                inputElem.addEventListener('change', () => { selectFile(inputElem); });
            }
        }
    });
}

function fileDragEnter(evt: DragEvent) {
    const mainElem = (<HTMLElement>evt.target).closest<HTMLElement>('[data-fileinput]');
    if (mainElem === null) {
        return;
    }
    setDisplayStyle(mainElem, true);
}

function fileDragLeave(evt: DragEvent) {
    const mainElem = (<HTMLElement>evt.target).closest<HTMLElement>('[data-fileinput]');
    if (mainElem === null) {
        return;
    }
    setDisplayStyle(mainElem, false);
}

function fileDrop(evt: DragEvent) {
    const inputElem = (<HTMLInputElement>evt.target);
    const mainElem = inputElem.closest<HTMLElement>('[data-fileinput]');
    if (mainElem === null || inputElem === null || inputElem === undefined) {
        return;
    }
    if (evt.dataTransfer?.items) {
        [...evt.dataTransfer.items].forEach((item, i) => {
            if (item.kind === 'file') {
                const file = item.getAsFile();
                if (file !== null && isFileValid(inputElem)) {
                    displayUploadFile(mainElem, file);
                }
            }
        });
    }
    else if (evt.dataTransfer?.files !== undefined) {
        [...evt.dataTransfer?.files].forEach((file, i) => {
            if (file !== null && isFileValid(inputElem)) {
                displayUploadFile(mainElem, file);
            }
        });
    }
    setDisplayStyle(mainElem, false);
}

function selectFile(elem: HTMLInputElement) {
    if (elem.files === null) {
        return;
    }
    const main = elem.closest<HTMLElement>('[data-fileinput]');
    if (main === null) {
        return;
    }
    main.querySelector<HTMLElement>('[data-error=invalid-filetype]')?.classList.add('hidden');
    if (elem.files.length > 0 && isFileValid(elem)) {
        displayUploadFile(main, elem.files[0]);
    }
    else {
        displayFileInput(main);
    }
}

function setDisplayStyle(mainElem: HTMLElement, isEnter: boolean) {
    const display = mainElem.querySelector('[data-fileinput-display]');
    if (isEnter === true) {
        display?.classList.add('bg-primary-lighter');
        display?.classList.add('border-gray');
    }
    else {
        display?.classList.remove('bg-primary-lighter');
        display?.classList.remove('border-gray');
    }
}

function isFileValid(elem: HTMLInputElement) {
    const fileTypeError = elem.closest<HTMLElement>('[data-fileinput]')?.querySelector<HTMLElement>('[data-error=invalid-filetype]');
    if (elem === null || elem.value === null || elem.value === "") {
        return false;
    }
    const filename = elem.value;
    const fileExt = elem.value.substring(filename.lastIndexOf("."));
    let found = false;
    elem.accept.split(',').forEach(ext => {
        if (fileExt === ext) {
            found = true;
            return;
        }
    });
    if (found === false) {
        fileTypeError?.classList.remove('hidden');
        return false;
    }
    return true;
}

function displayFileInput(mainElem: HTMLElement) {
    if (mainElem === null) {
        return;
    }
    const selectedFilename = mainElem.querySelector<HTMLElement>('[data-selected-filename]');
    mainElem.querySelector<HTMLElement>('[data-default=main]')?.classList.remove('hidden');
    mainElem.querySelector<HTMLElement>('[data-preview=main]')?.classList.add('hidden');
    if (selectedFilename !== null) {
        selectedFilename.innerText = "No files selected.";
    }
}

function displayUploadFile(mainElem: HTMLElement, file: File) {
    const selectedFilename = mainElem.querySelector<HTMLElement>('[data-selected-filename]');
    const previewFilename = mainElem.querySelector<HTMLElement>('[data-preview=filename]');
    mainElem.querySelectorAll<HTMLElement>('[data-preview-img]').forEach(img => img.classList.add('hidden'));   
    mainElem.querySelector<HTMLElement>('[data-default=main]')?.classList.add('hidden');
    mainElem.querySelector<HTMLElement>('[data-preview=main]')?.classList.remove('hidden');         
    if (mainElem === null) {
        return;
    }

    if (selectedFilename !== null) {
        selectedFilename.innerText = `You have selected the file: ${file.name}`;
    }
    if (previewFilename !== null) {
        previewFilename.innerText = file.name;
    }

    switch (file.name.substring(file.name.lastIndexOf('.'))) {
        case ".doc":
        case ".docx":
            mainElem.querySelector<HTMLElement>('[data-preview-img=word]')?.classList.remove('hidden');
            break;
        case ".pdf":
            mainElem.querySelector<HTMLElement>('[data-preview-img=pdf]')?.classList.remove('hidden');
            break;
        default:
            mainElem.querySelector<HTMLElement>('[data-preview-img=file]')?.classList.remove('hidden');
    }
}

document.addEventListener('DOMContentLoaded', (event) => {
    bindFileInputs(document);
});
